module.exports = __webpack_public_path__ + "img/friday.e14f3910.jpg";